
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { retry, map } from 'rxjs/operators';
import {ActivatedRoute, Router} from '@angular/router';
import {LoggedUser} from "./_Models/logged-user";
import {QrMessage} from "./_Models/qr-message";
import {ApiRestService} from "./api-rest.service";
import {Login} from "./_Models/login";

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<LoggedUser>;
  public currentUser: Observable<LoggedUser>;

  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private ApiRestService: ApiRestService
  ) {
    this.currentUserSubject = new BehaviorSubject<LoggedUser>(JSON.parse(localStorage.getItem('User')));
    this.currentUser = this.currentUserSubject.asObservable();
  }
  public get currentUserValue(): LoggedUser {
    return this.currentUserSubject.value;
  }
  updateuser(user){ this.currentUserSubject.next(user);}
  login(Qr: QrMessage) {
    return this.http.post<Login>(
      `${Qr.synfra_url}/api/tab-console/connect`,
      JSON.stringify(Qr),{headers:{'Content-Type': 'application/json'}}).pipe(map((data) => {
      var loggedUser: LoggedUser = {
        token: data?.token?.token,
        synfra_url: Qr.synfra_url,
        device_id: Qr.device_id,
        idOrgano: Qr.idOrgano,
        session_id: Qr.session_id
      }
      console.log(data);
      localStorage.setItem('User', JSON.stringify(loggedUser));
      this.currentUserSubject.next(loggedUser);
      console.log("UTENTE LOGGATO: ", loggedUser);
      this.router.navigate([this.route.snapshot.queryParams["/console/emendamento"] || "/console/emendamento",])
      return data;
    })) ;
  }

}
